<template>
  <section>
    <div class="settings-header">
      {{ __(title) }}
      <div class="d-flex align-items-center ml-auto">
        <div class="d-lg2-inline d-none ml-4 position-relative">
          <input
            class="search-field pl-5"
            type="text"
            name="filter"
            :placeholder="__('Digite para pesquisar...')"
            v-model="filter"
            @keydown.enter="getBoard()"
          />
          <img
            src="/build/icons/search-icon.svg"
            width="16"
            height="16"
            alt="Lupa do campo de pesquisa"
            class="position-absolute search-icon-image-container"
          />
          <a
            id="clear-search-field"
            class="position-absolute clear-search-field"
            aria-label="Close"
            v-show="filter"
            @click="clearSearchField"
          >
            <span aria-hidden="true">×</span>
          </a>
        </div>
      </div>
      <div v-if="(type == 'lead' && canStatus?.store) ||  (type != 'lead' && canReason?.store)" class="ml-3 position-relative">
        <button
          class="btn btn-primary ml-auto btn-config-add-status"
          @click.prevent="open()"
        >
          {{ __(buttonText) }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="form-text">
          {{ __(description) }}
        </p>
        <div class="row">
          <div
            class="col-12"
            v-if="state.loading"
          >
            <i class="fa fa-circle-o-notch fa-spin mt-4" />
          </div>
          <div
            class="col-12"
            v-else
          >
          <div class="d-flex align-items-center dragglable-title">
            <p>{{ __(tableTitle) }}</p>
            <div
              v-if="sortable"
              @click="sort"
              class="arrow-box"
              v-b-tooltip.right="__('Ordenar')"
            >
              <SortArrows color="#8869FD"/>
            </div>
          </div>
            <Draggable
              class="settings-group list-group"
              tag="ul"
              :list="statuses"
              :group="'status'"
              :sort="!state.moving && ((type == 'lead' && canStatus?.order) ||  (type != 'lead' && canReason?.order))"
              @update="order"
              :disabled="!((type == 'lead' && canStatus?.order) || (type != 'lead' && canReason?.order))"
            >
              <li
                class="list-group-item d-flex align-items-center"
                :key="status.id"
                v-for="status in statuses"
              >
                <span class="mr-3">{{ status.name }}</span><span
                  class="ml-auto mt-n1px"
                  v-if="status.editable"
                >
                <a v-if="(type == 'lead' && canStatus?.update) ||  (type != 'lead' && canReason?.update)" class="ml-3"
                  href="#"
                  v-b-tooltip.left="__('Editar')"
                  @click.prevent="open(status)">
                  <IconPencilFilled :size="18" /></a>

                <a v-if="(type == 'lead' && canStatus?.delete) || (type != 'lead' && canReason?.delete)"
                  class="ml-3"
                  href="#"
                  v-b-tooltip.left="__('Excluir')"
                  @click.prevent="openDeleteStatusModal(status)"
                >
                  <IconTrash :size="18" /></a></span>
              </li>
            </Draggable>
          </div>
        </div>
      </div>
    </div>

    <DeleteStatusModal
      v-if="isDeleteModalOpen"
      :statuses="statuses"
      :currentStatus="currentStatus"
      :type=type
      :title=deleteModalTitle
      @close-modal="closeDeleteStatusModal"
      @remove-status="removeStatus"
    />

    <BModal
      id="status-modal"
      ref="status-modal"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ modalTitle }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <div class="form-group">
          <label>{{ __('Nome') }}</label>
          <input
            class="form-control"
            type="text"
            name="name"
            v-model="editing.name"
            maxlength="80"
          >
        </div>
      </template>
      <div class="d-flex flex-column modal-footer default-modal-footer p-0 mt-3">
        <button
          class="btn btn-primary btn-save"
          type="button"
          :disabled="state.saving"
          @click.prevent="store"
        >
          <span v-if="state.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
        </button>
        <button
          class="btn pb-0 btn-cancel"
          type="button"
          :disabled="state.saving"
          @click.prevent="close"
        >
          <u>{{ __('Cancelar') }}</u>
        </button>
      </div>
    </BModal>
  </section>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import DeleteStatusModal from './DeleteStatusModal.vue';
import SortArrows from '../icon/SortArrows.vue'

export default {
  props: ['type'],

  components: {
    BModal,
    DeleteStatusModal,
    SortArrows
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    tableTitle: {
      type: String,
      required: true
    },
    sortable: {
      type: Boolean,
      required: true
    },
    canStatus: {
      type: Object
    },
    canReason: {
      type: Object
    },
    deleteModalTitle: {
      type: String,
      required: true
    },
  },

  data () {
    return {
      statuses: [],
      editing: {},
      filter: '',
      state: {
        loading: true,
        moving: false,
        saving: false,
        editing: false,
      },
      currentStatus: null,
      isDeleteModalOpen: false,
      sortOrder: null,
    };
  },

  created () {
    this.fetch();
  },

  computed: {
      modalTitle() {
          return `${this.state.editing ? 'Editar' : 'Adicionar'} ${this.type === 'lead' ? 'Status' : 'Motivo'}`;
      },
  },

  methods: {
    fetch () {
      const url = this.getStatusFetchURlWithParams();

      this.$http.get(url)
        .then(({ data: statuses }) => {
          this.statuses = statuses;
          this.state.loading = false;
        });
    },

    getStatusFetchURlWithParams(query=null) {
      const params = new URLSearchParams({ type: this.type });
      if(this.sortOrder && this.type !== 'lead') params.append('order', this.sortOrder);
      if(query) params.append('q', query);
      const url = `settings/status?${params.toString()}`;
      return url;
    },

    getBoard() {
      const url = this.getStatusFetchURlWithParams(this.filter);

      this.$http.get(url)
        .then(({ data: statuses }) => {
          this.statuses = statuses;
        });
    },

    order () {
      const order = this.statuses.filter((status) => status.editable).map((status) => status.id);

      this.state.moving = true;

      this.$http.put('settings/status/order', { order, type: this.type })
        .then(() => Alert.success(this.__('Ordem alterada.')))
        .catch(({ data }) => {
          const message = data.message || data.error || __('Erro ao alterar ordem.');

          Alert.error(message);

          this.fetch();
        })
        .finally(() => this.state.moving = false);
    },

    store () {
      this.state.saving = true;

      this.getAction()
        .then(() => {
          if (this.state.editing) {
            return Alert.success(this.__('Status alterado!'));
          }

          Alert.success(this.__('Status cadastrado!'));
        })
        .catch(({ data }) => {
          const message = data?.message || data?.error || data?.name || __('Erro ao cadastrar ou alterar status.');

          Alert.error(message);
        })
        .finally(() => {
          this.close();

          this.state.saving = false;
        });
    },

    getAction () {
      if (this.state.editing) {
        return this.$http.put(`settings/status/${this.editing.id}`, this.editing)
          .then(({ data: status }) => {
            this.statuses.find((s) => s.id == status.id).name = status.name;
          });
      }

      const params = new URLSearchParams({ type: this.type });
      const url = `settings/status?${params.toString()}`;
      return this.$http.post(url, this.editing)
        .then(({ data: status }) => this.statuses.push(status));
    },

    removeStatus(status) {
      this.statuses.splice(this.statuses.indexOf(status), 1);
    },

    open (status = {}) {
      this.editing = _.clone(status);
      this.state.editing = ! _.isEmpty(status);

      this.$refs['status-modal'].show();
    },

    close () {
      this.$refs['status-modal'].hide();
    },

    openDeleteStatusModal(status) {
      this.currentStatus = status;
      this.isDeleteModalOpen = true;
    },

    closeDeleteStatusModal() {
      this.currentStatus = null;
      this.isDeleteModalOpen = false;
    },

    clearSearchField () {
      this.filter = '';
      this.fetch();
    },

    sort () {
      if(!this.sortOrder) {
        this.sortOrder = 'desc';
      } else {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      }
      this.fetch();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.btn-cancel {
  font-size: 11px;
}

.btn-config-add-status {
  background: $salesflow-secondary;
  color: $salesflow-font-dark;
  min-width: 164px;
  height: 42px;
  padding: 10px 24px;
  border-radius: 14px;

  &:hover {
    cursor: pointer;
    background: $salesflow-secondary-hover;
    color: $white;
  }
}

.search-icon-image-container {
  left: 24px;
  top: 13px;
}

.search-field {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: $salesflow-font-gray !important;
  background: #FFF;
  border-radius: 14px !important;
  border: 1px solid $salesflow-outline-gray-medium;
  padding: 7px 32px;
  outline: 0;
  min-width: 225px;
  width: 225px;
  height: 42px;
}

.clear-search-field {
  top: 11px;
  right: 12px;
  font-size: 32px;
  color: $salesflow-font-gray !important;

  &:hover {
    cursor: pointer;
  }

  span {
    font-weight: 100;
  }
}

.search-field::placeholder {
  font-size: 0.75rem;
  font-weight: 400;
  color: $salesflow-font-gray !important;
}

.dragglable-title {
  background-color: #E4DDFF;
  border-radius: 8px 8px 0px 0px;

  p {
   font-family: 'Montserrat';
   font-weight: 600;
   font-size: 14px;
   line-height: 21px;
   color: #7C5EE8;
   margin: 12px 4px 12px 16px;
  }
}

.list-group {
  font-family: 'Montserrat';
  color: $salesflow-font-dark;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 21px;
}

.list-group-item {
  border-color: #E0DBE8;
}

.arrow-box {
  cursor: pointer;
  border-radius: 8px;
  background: transparent;
  border: 1px solid transparent;
  padding: 5px 6px;
}

.arrow-box:hover {
  border-radius: 8px;
  border: 1px solid #D2C5FF;
  background: #D2C5FF;
  padding: 5px 6px;
}

.settings-header {
  line-height: 20.8px !important;
  margin-bottom: 14px !important;
}

.form-text {
  margin-top: 0 !important;
}

::v-deep .tooltip-inner {
  padding: 8px 12px 8px 12px !important;
  border-radius: 8px !important;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
}

  ::v-deep .modal-content {
    width: 415px;
    height: 284px;
    border: 0;
  }

  ::v-deep .modal-body {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 16px 24px 24px 24px;
    background-color: $salesflow-background-content;
  }

  ::v-deep .form-control {
    background-color: $salesflow-font-white;
    width: 367px;
    height: 52px;
    padding: 13px 12px 13px 12px;
    border: 1px solid $salesflow-outline-gray-medium;
    border-radius: 8px;
    font-size: 16px;
    color: $salesflow-font-dark;
  }

  ::v-deep .form-control:focus{
    border: 1px solid #86B7FE;
    border-color: #86B7FE !important;
    box-shadow: 0 0 0 0.25rem #0D6EFD40 !important;
  }

  ::v-deep .modal-header {
    padding: 16px 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  ::v-deep .modal-title {
    font-family: 'Montserrat';
    font-size: 12px;
  }

  ::v-deep .modal-footer {
    background-color: $salesflow-background-content;
  }

  .btn-save {
    margin-top: 16px;
    margin-right: 0;
    background-color: $salesflow-secondary;
    color: $salesflow-font-dark;
    font-size: 16px;

    &:hover {
      background: $salesflow-secondary-hover;
      color: $white;
    }
  }

  .btn-cancel {
    color: #71767D;
    font-size: 12px;
    line-height: 18px;
    padding: 0;
    margin-top: 16px;
    margin-left: 0
  }

  .btn-cancel:hover{
    color: $salesflow-primary-hover;
  }
</style>
